var FormType;
(function (FormType) {
    FormType["Default"] = "default";
    FormType["Card"] = "card";
    FormType["Inline"] = "inline";
    FormType["Flat"] = "flat";
})(FormType || (FormType = {}));
export default FormType;
